import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DatesService {
  dateIsExpired(date: Date): boolean {
    let isExpired = false;
    const today = new Date();
    const dateToCheck = new Date(date);
    if (today > dateToCheck) {
      isExpired = true;
    }
    return isExpired;
  }
  dateWillExpire(date: Date, beforeDays: number): boolean {
    let willExpire = false;
    const today = new Date();
    const dateBefore = new Date(today.getTime() - beforeDays * 24 * 60 * 60 * 1000);
    const dateToCheck = new Date(date);
    if (dateBefore > dateToCheck) {
      willExpire = true;
    }
    return willExpire;
  }
}
